import { EventPanelIcons } from "../../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
import { EventTitleFlex } from "../../../../lib/comps/PropPanel/EventPanelNew/EventTitleFlex";
import SimpleFlowStepList from "../../../../lib/simpleFlow/SimpleFlowEditor/SimpleFlowStepList";
const __script_base__ = {
  name: 'BranchElseEditor',
  components: {
    SimpleFlowStepList,
    EventTitleFlex
  },
  data() {
    return {
      arrowDownIcon: EventPanelIcons.arrowDown,
      deleteIcon: EventPanelIcons.deleteIcon
    };
  },
  props: {
    value: Object
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    addBranch() {
      this.$set(this.value, 'enable', true);
      this.$set(this.value, 'expanded', true);
    },
    deleteBranch() {
      this.$set(this.value, 'enable', false);
      this.$set(this.value, 'disabled', false);
      this.$set(this.value, 'expanded', false);
      this.$set(this.value, 'steps', []);
    },
    toggleDisabled() {
      this.$set(this.value, 'disabled', !this.value.disabled);
    },
    toggleExpanded() {
      this.$set(this.value, 'expanded', !this.value.expanded);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-sfeList ucd-IfSwitchBranchList"
  }, [!!_vm.value.enable ? _c("EventTitleFlex", {
    staticClass: "ucd-sfeStep ucd-ifSwitchBranchEditor ucd-IfSwitchBranchList-branch",
    class: {
      isExpanded: !!_vm.value.expanded,
      isDisabled: !!_vm.value.disabled
    },
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c("a-tooltip", {
    attrs: {
      slot: "toggle",
      placement: "leftTop",
      title: _vm.value.disabled ? "分支已禁用，点击启用" : "点击禁用分支"
    },
    on: {
      click: _vm.toggleDisabled
    },
    slot: "toggle"
  }, [_c("div", {
    staticClass: "ucd-sfeStep-toggle"
  }, [_c("div", {
    class: "ucd-sfeToggle small " + (_vm.value.disabled ? "isGrey" : "isYellow")
  })])]), _vm._v(" "), _c("div", {
    staticClass: "ucd-sfeStep-title ucd-ifSwitchBranchEditor-header",
    attrs: {
      slot: "title"
    },
    on: {
      click: _vm.toggleExpanded
    },
    slot: "title"
  }, [_c("div", {
    staticClass: "ucd-sfeStep-title-name ucd-ifSwitchBranchEditor-title"
  }, [_c("div", [_vm._v("\n           else分支\n        ")])]), _vm._v(" "), _c("div", {
    staticClass: "ucd-sfeStep-actions",
    on: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("button", {
    staticClass: "ucd-sfeStep-button ucd-sfeStep-arrowButton",
    on: {
      click: _vm.toggleExpanded
    }
  }, [_c("img", {
    class: {
      Rotate: _vm.value.expanded
    },
    attrs: {
      src: _vm.arrowDownIcon
    }
  })]), _vm._v(" "), _c("button", {
    staticClass: "ucd-sfeStep-button",
    attrs: {
      slot: "actions",
      title: "删除分支"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.deleteBranch.apply(null, arguments);
      }
    },
    slot: "actions"
  }, [_c("img", {
    attrs: {
      src: _vm.deleteIcon
    }
  })])])]), _vm._v(" "), _vm.value.expanded ? _c("div", {
    staticClass: "ucd-sfeStep-params"
  }, [_c("SimpleFlowStepList", {
    attrs: {
      steps: _vm.value.steps
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !_vm.value.enable ? _c("div", {
    class: ["ucd-sfeList-footer", "footerTab"],
    staticStyle: {
      "margin-top": "-12px",
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.addBranch.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "ucd-sfeToggle isYellow ucd-sfeList-footer-plusIcon smallToggleIcon"
  }, [_vm._v("\n      ＋\n    ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-sfeList-footer-textBox ucd-IfSwitchBranchList-addBranch isInFilledList"
  }, [_c("div", [_vm._v("\n        添加else分支\n      ")])]);
}];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/designerComponents/BranchElseEditor/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);